import formFieldRepeatableComponent from './form-field-repeatable.component';

const formFieldRepeatableModule = angular.module('formFieldRepeatable', [
])
  .component('formFieldRepeatable', formFieldRepeatableComponent)
  .name;

export default formFieldRepeatableModule;
